/*
 * Shipping Protection checkout block — see snippets/shipping-protection.liquid.
 *
 * Reproduces the Simply Insurance storefront widget in theme code so the block
 * looks and behaves the same whether or not the shopper accepted cookies.
 *
 * The premium logic is ported from the app's own script
 * (simply-insurance_05-06-26.js: checkEligibility, skipProducts,
 * planTypePercentage, planTypeFixed) including its float arithmetic, so a tie
 * between two tiers resolves exactly the way the app resolves it. Do not
 * "tidy" the maths into integer cents: that changes which tier wins a tie.
 */
(function () {
  'use strict';

  var CART_UPDATE = '/cart/update.js';
  var CART_JS = '/cart.js';

  // ----------------------------------------------------------- app config --

  function readConfig() {
    var si = window.simplyInsurance;
    var plan = si && si.insurancePlan;
    // The app embed assigns the plan as a JSON string and parses it on the next
    // line; cope with catching it before that.
    if (typeof plan === 'string') {
      try { plan = JSON.parse(plan); } catch (e) { return null; }
    }
    if (!plan || plan.is_app_enable !== 'yes') return null;

    var plans = plan.planArray;
    if (!Array.isArray(plans) || !plans.length) return null;
    // The app refuses to run with a tier that has no variant behind it.
    for (var i = 0; i < plans.length; i++) if (!plans[i].variant_id) return null;

    var text = window.sspStorefrontCustomization || {};

    return {
      plan: plan,
      plans: plans,
      variantIds: plans.map(function (p) { return String(p.variant_id); }),
      skipSkus: si.skipSkus || [],
      skipPids: si.skipPids || [],
      skipHandles: si.skipHandles || [],
      minOrderValue: si.minOrderValue || 0,
      moneyFormat: si.money_format || (window.theme && window.theme.moneyFormat) || '${{amount}}',
      labelText: text.ssp_checkout_label_text_content || 'Checkout + Shipping Protection • ##plan_price',
      buttonText: text.ssp_checkout_btn_text_content || 'Checkout + ##plan_price## (Protection)',
      skipText: text.ssp_secondary_btn_text_content || 'Checkout without shipping protection',
      showSkip: text.ssp_add_secondary_btn !== false,
      tooltip: text.ssp_checkout_label_tooltip || plan.tool_tip_message || ''
    };
  }

  // ------------------------------------------------ app logic, ported as-is --

  // simply-insurance: i()
  function amount(t) {
    try {
      t = parseFloat(t).toFixed(2);
      t *= 100;
      return t;
    } catch (e) {
      return t;
    }
  }

  function isProtectionLine(line, cfg) {
    return cfg.variantIds.indexOf(String(line.variant_id)) !== -1;
  }

  // simply-insurance: filterInsuranceProduct() + skipProducts()
  function coveredLines(lines, cfg) {
    return lines.filter(function (line) {
      return !isProtectionLine(line, cfg) &&
        cfg.skipSkus.indexOf(line.sku) === -1 &&
        cfg.skipPids.indexOf(line.product_id) === -1 &&
        cfg.skipHandles.indexOf(line.handle) === -1;
    });
  }

  // simply-insurance: checkEligibility() — the premium is based on this.
  function baseAmount(lines, cfg) {
    var r = 0;
    coveredLines(lines, cfg).map(function (line) { r += line.final_line_price; });
    return r;
  }

  // simply-insurance: planTypePercentage() — nearest tier, earlier tier on a tie.
  function selectPercentage(base, cfg) {
    var e;
    var a = cfg.plans;
    var c = base * parseFloat(cfg.plan.cart_percentage) / 100;
    for (var u = 0; u < a.length; u++) {
      var l = a[u];
      var f = a[u];
      e ? f = e : e = l;
      var p = amount(l.insurance_plan_amount);
      var h = amount(f.insurance_plan_amount);
      var d = Math.abs(p - c);
      e = Math.abs(h - c) > d ? l : f;
    }
    return e || a[a.length - 1];
  }

  // simply-insurance: planTypeFixed() — last matching range wins, then the
  // global rule.
  function selectFixed(base, cfg) {
    var chosen = null;
    cfg.plans.map(function (n) {
      var r = amount(n.min_order_price);
      var o = amount(n.max_order_price);
      if (base >= r && base <= o) chosen = n;
    });
    if (!chosen) {
      cfg.plans.map(function (t) { if (t.is_gloabal_rule === 'Yes') chosen = t; });
    }
    return chosen;
  }

  function choosePlan(base, cfg) {
    if (base === 0 || cfg.minOrderValue > base) return null;
    return cfg.plan.insurance_plan_type === 'percentage' ? selectPercentage(base, cfg) : selectFixed(base, cfg);
  }

  // --------------------------------------------------------------- display --

  function formatMoney(value, format) {
    var fixed = Number(value).toFixed(2);
    var parts = fixed.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return String(format).replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withCommas;
        case 'amount_with_comma_separator': return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
        case 'amount_no_decimals_with_comma_separator': return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        default: return withCommas + '.' + parts[1];
      }
    });
  }

  function withPrice(template, price) {
    return String(template).replace(/##plan_price##/g, price).replace(/##plan_price/g, price);
  }

  function plainButtons(block) {
    var selector = block.getAttribute('data-plain-checkout');
    if (!selector) return [];
    var scope = block.closest('.previewCartGroup, .action-group') || document;
    return Array.prototype.slice.call(scope.querySelectorAll(selector));
  }

  function offerPlainCheckout(block) {
    block.hidden = true;
    block.removeAttribute('data-variant-id');
    plainButtons(block).forEach(function (button) { button.hidden = false; });
  }

  function offerProtection(block, chosen, cfg) {
    var price = formatMoney(chosen.insurance_plan_amount, cfg.moneyFormat);

    block.querySelector('[data-hdx-protection-label]').textContent = withPrice(cfg.labelText, price);
    block.querySelector('[data-hdx-protection-button]').textContent = withPrice(cfg.buttonText, price);

    var skip = block.querySelector('[data-hdx-protection-skip]');
    skip.textContent = cfg.skipText;
    skip.hidden = !cfg.showSkip;

    if (cfg.tooltip) {
      var info = block.querySelector('[data-hdx-protection-tooltip]');
      info.setAttribute('aria-label', cfg.tooltip);
      block.querySelector('[data-hdx-protection-tooltip-text]').textContent = cfg.tooltip;
    }

    block.setAttribute('data-variant-id', String(chosen.variant_id));
    block.hidden = false;
    plainButtons(block).forEach(function (button) { button.hidden = true; });
  }

  // -------------------------------------------------------------- cart I/O --

  function readLines(block) {
    var el = block.querySelector('[data-hdx-protection-cart]');
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      // X-REF marks the request the way the app marks its own, so the app's
      // fetch/XHR hooks (when its script is allowed to run) leave it alone.
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-REF': '1' },
      body: JSON.stringify(body)
    });
  }

  // Protection lines currently in the cart, read fresh so a stale render can
  // never leave two tiers behind.
  function protectionLinesInCart(cfg) {
    return fetch(CART_JS, { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        return (cart.items || []).filter(function (line) { return isProtectionLine(line, cfg); });
      });
  }

  function refreshCartView() {
    if (document.body.classList.contains('template-cart')) {
      window.location.reload();
      return;
    }
    var refresh = window.sharedFunctions && window.sharedFunctions.updateSidebarCart;
    if (typeof refresh === 'function' && window.Shopify && typeof window.Shopify.getCart === 'function') {
      window.Shopify.getCart(function (cart) { refresh(cart); });
    }
  }

  function checkoutUrl(block) {
    var skip = block.querySelector('[data-hdx-protection-skip]');
    return (skip && skip.getAttribute('href')) || '/checkout';
  }

  // The theme can require a terms checkbox before checkout.
  function termsAccepted(block) {
    var scope = block.closest('.previewCartAction, .cart-total, form') || document;
    var box = scope.querySelector('.global-checkbox--input');
    if (!box || box.checked) return true;
    box.focus();
    return false;
  }

  function warn(message) {
    if (typeof window.showWarning === 'function') {
      window.showWarning(message, 5000);
    } else {
      window.alert(message);
    }
  }

  function checkoutWithProtection(block, button) {
    var cfg = readConfig();
    var variantId = block.getAttribute('data-variant-id');
    if (!cfg || !variantId || !termsAccepted(block)) return;

    button.disabled = true;
    button.classList.add('is-loading');

    protectionLinesInCart(cfg)
      .then(function (existing) {
        var updates = {};
        existing.forEach(function (line) { updates[line.variant_id] = 0; });
        updates[variantId] = 1;
        return post(CART_UPDATE, { updates: updates });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('cart update failed: ' + res.status);
        window.location.href = checkoutUrl(block);
      })
      .catch(function (error) {
        console.error('[shipping-protection]', error);
        button.disabled = false;
        button.classList.remove('is-loading');
        warn('Shipping Protection could not be added. Please try again.');
      });
  }

  function checkoutWithout(block, link) {
    var cfg = readConfig();
    var go = function () { window.location.href = checkoutUrl(block); };
    if (!termsAccepted(block)) return;
    if (!cfg) { go(); return; }

    link.classList.add('is-loading');

    // Like the app: take protection out, then check out even if that fails.
    protectionLinesInCart(cfg)
      .then(function (existing) {
        if (!existing.length) return null;
        var updates = {};
        existing.forEach(function (line) { updates[line.variant_id] = 0; });
        return post(CART_UPDATE, { updates: updates });
      })
      .then(go, go);
  }

  // ------------------------------------------------------------------ wire --

  function render(block) {
    var cfg = readConfig();
    if (!cfg) {
      offerPlainCheckout(block);
      return;
    }

    var lines = readLines(block);
    var chosen = choosePlan(baseAmount(lines, cfg), cfg);

    if (!chosen) {
      offerPlainCheckout(block);
      // Nothing left to protect — the app removes a leftover protection line
      // here so a cart can never check out with protection alone.
      if (lines.some(function (line) { return isProtectionLine(line, cfg); })) {
        protectionLinesInCart(cfg).then(function (existing) {
          // When the shopper has accepted cookies the app's own script runs too
          // and may have removed the line first. Either way this render is now
          // out of date, so refresh it.
          if (!existing.length) return refreshCartView();
          var updates = {};
          existing.forEach(function (line) { updates[line.variant_id] = 0; });
          return post(CART_UPDATE, { updates: updates }).then(refreshCartView);
        }).catch(function (error) { console.error('[shipping-protection]', error); });
      }
      return;
    }

    offerProtection(block, chosen, cfg);
  }

  function renderAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hdx-protection]'), function (block) {
      block.setAttribute('data-hdx-rendered', '');
      render(block);
    });
  }

  // The drawer body and the cart page totals are both re-rendered by AJAX
  // after every cart change; a freshly inserted block starts hidden, so pick
  // up any block that has not been rendered yet, whatever inserted it.
  var pending = false;
  function renderNew() {
    pending = false;
    Array.prototype.forEach.call(document.querySelectorAll('[data-hdx-protection]:not([data-hdx-rendered])'), function (block) {
      block.setAttribute('data-hdx-rendered', '');
      render(block);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-hdx-protection-checkout]');
    if (button) {
      event.preventDefault();
      checkoutWithProtection(button.closest('[data-hdx-protection]'), button);
      return;
    }

    var link = event.target.closest('[data-hdx-protection-skip]');
    if (link) {
      event.preventDefault();
      checkoutWithout(link.closest('[data-hdx-protection]'), link);
    }
  });

  document.addEventListener('cart-drawer:rendered', renderAll);

  function boot() {
    renderAll();
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(renderNew);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Exposed for verification from the console; not used by the theme.
  window.HDXShippingProtection = { choosePlan: choosePlan, readConfig: readConfig, baseAmount: baseAmount };
}());
